import React from 'react';
import { Spinner, Placeholder } from '@wordpress/components';
import { useBlockAJAXPreview, usePreventInnerEventsRef } from '../hooks';
import { useSelect } from '@wordpress/data';
import { getBlockContent } from '@wordpress/blocks';
import { store as blockEditorStore } from '@wordpress/block-editor';

/**
 * Component for getting content of server-side rendered blocks such as gp-entry-blocks/entries-table.
 *
 * Ideally, we would use ServerSideRender, but it does not support passing the block context.
 *
 * @param props
 */
const BlockPreview = (
	props: BlockProps<any> & { tag?: string; includeContent?: boolean } & {
		[key: string]: any;
	}
) => {
	const { clientId } = props;

	const block = useSelect(
		(select) => select(blockEditorStore).getBlock(clientId),
		[clientId]
	);

	const content = props.includeContent ? getBlockContent(block) : undefined;

	const previewHTML = useBlockAJAXPreview(props, content);
	const ref = usePreventInnerEventsRef(previewHTML);

	/* Do not attempt to render the block without context as the selected form and other settings won't be available (e.g. Style preview */
	if (!Object.keys(props.context).length) {
		return undefined;
	}

	const Tag = props.tag ?? 'div';

	if (!previewHTML) {
		return (
			// @ts-ignore
			<Tag
				className="gpeb-block-preview"
				// @ts-ignore
				ref={ref}
			>
				<Placeholder>
					<Spinner />
				</Placeholder>
			</Tag>
		);
	}

	// Get the extra props such as tabIndex, role, style, className, etc, but not tab, includeContent, etc.
	const extraProps = {
		tabIndex: props?.tabIndex,
		role: props?.role,
		style: props?.style,
		className: props?.className,
		onClick: props?.onClick,
		onKeyPress: props?.onKeyPress,
	};

	return (
		<Tag
			className="gpeb-block-preview"
			// @ts-ignore
			ref={ref}
			dangerouslySetInnerHTML={{ __html: previewHTML }}
			{...extraProps}
		/>
	);
};

export default BlockPreview;
